import type { PublicRouteClassifierContribution } from '#kernel/public-site/public-route-classifier-types.ts';

export const websitePublicRoutePaths = {
  attorney: '/attorney/:id',
  booking: '/free-consultation',
  firmDirectory: '/firms',
  directoryFirm: '/firms/:firmSlug',
  directoryFirmAttorney: '/firms/:firmSlug/attorneys/:id',
  directoryFirmBooking: '/firms/:firmSlug/free-consultation',
  homeMockup: '/home-mock-up-design',
  landing: '/',
  omarMockup: '/omar-mock-up-design',
  privacy: '/privacy-policy',
} as const;

export default {
  id: 'website',
  paths: Object.values(websitePublicRoutePaths),
} satisfies PublicRouteClassifierContribution;
